(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
// Quick View Functions
window.openCollQV = function(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4) {
  const modal = document.getElementById('collQVModal');
  const body = document.getElementById('collQVBody');
  
  if (!modal || !body) return;
  
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';
  body.innerHTML = '<div class="coll-qv-loading"><div class="coll-qv-spinner"></div></div>';
  
  setTimeout(() => {
    const hasCompare = comparePrice && comparePrice !== '' && comparePrice !== price;
    const images = [image, img2, img3, img4].filter(img => img && img !== '');
    
    let thumbnailsHTML = '';
    if (images.length > 1) {
      thumbnailsHTML = `
        <div class="coll-qv-thumbs">
          ${images.map((img, index) => `
            <button type="button" class="coll-qv-thumb ${index === 0 ? 'active' : ''}" onclick="changeCollQVImg('${img}', this)">
              <img src="${img}" alt="Thumbnail ${index + 1}">
            </button>
          `).join('')}
        </div>
      `;
    }
    
    body.innerHTML = `
      <div class="coll-qv-grid">
        <div class="coll-qv-images">
          <div class="coll-qv-main-img">
            <div class="coll-qv-img-loader"></div>
            <img src="${image}" alt="${title}" id="collQVMainImg" onload="this.classList.add('loaded'); this.previousElementSibling.remove();">
          </div>
          ${thumbnailsHTML}
        </div>
        
        <div class="coll-qv-info">
          <h1 class="coll-qv-title">${title}</h1>
          
          <div class="coll-qv-price-display">
            ${hasCompare ? `<span class="coll-price-compare">${comparePrice}</span>` : ''}
            <span class="${hasCompare ? 'coll-price-sale' : 'coll-price-regular'}">${price}</span>
          </div>
          
          <form class="coll-qv-form" onsubmit="return handleCollQVATC(event, '${variantId}')">
            <div class="coll-qv-qty-row">
              <label>Quantity</label>
              <div class="coll-qv-qty-box">
                <button type="button" class="coll-qv-qty-btn" onclick="changeCollQVQty(-1)">−</button>
                <input type="number" id="collQVQtyInput" value="1" min="1" class="coll-qv-qty-input" readonly>
                <button type="button" class="coll-qv-qty-btn" onclick="changeCollQVQty(1)">+</button>
              </div>
            </div>
            
            <div class="coll-qv-actions">
              <button type="submit" class="coll-qv-add-btn" ${available !== 'true' ? 'disabled' : ''}>
                ${available === 'true' ? 'Add to Cart' : 'Sold Out'}
              </button>
              <a href="${url}" class="coll-qv-view-link">View Full Details</a>
            </div>
          </form>
        </div>
      </div>
    `;
  }, 100);
};

window.closeCollQV = function() {
  const modal = document.getElementById('collQVModal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(() => {
      const body = document.getElementById('collQVBody');
      if (body) {
        body.innerHTML = '<div class="coll-qv-loading"><div class="coll-qv-spinner"></div></div>';
      }
    }, 300);
  }
};

window.changeCollQVImg = function(imageSrc, thumbButton) {
  const mainImg = document.getElementById('collQVMainImg');
  const allThumbs = document.querySelectorAll('.coll-qv-thumb');
  allThumbs.forEach(thumb => thumb.classList.remove('active'));
  thumbButton.classList.add('active');
  mainImg.classList.remove('loaded');
  mainImg.src = imageSrc;
};

window.changeCollQVQty = function(delta) {
  const input = document.getElementById('collQVQtyInput');
  if (input) {
    const current = parseInt(input.value) || 1;
    const newValue = current + delta;
    if (newValue >= 1) {
      input.value = newValue;
    }
  }
};

window.handleCollQVATC = function(event, variantId) {
  event.preventDefault();
  
  const qtyInput = document.getElementById('collQVQtyInput');
  const quantity = qtyInput ? parseInt(qtyInput.value) : 1;
  const button = event.target.querySelector('.coll-qv-add-btn');
  
  if (button) {
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      button.textContent = '✓ Added!';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.Shopify) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      setTimeout(() => {
        closeCollQV();
      }, 1200);
    })
    .catch(error => {
      console.error('Error:', error);
      button.textContent = 'Error - Try Again';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
  }
  
  return false;
};

// ESC key to close
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCollQV();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-modular"] && !Shopify.designMode) return;
  try {
    
// Quick View Functions - Define FIRST
function openQuickView(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4) {
  console.log('Opening Quick View');
  
  const modal = document.getElementById('quickViewModalGlobal');
  const body = document.getElementById('qvBody');
  
  if (!modal || !body) {
    console.error('Modal elements not found');
    return;
  }
  
  // Show modal with animation
  modal.classList.add('qv-active');
  document.body.style.overflow = 'hidden';
  
  // Show loading state
  body.innerHTML = '<div class="qv-loading-state"><div class="qv-spinner"></div></div>';
  
  // Small delay for smooth animation
  setTimeout(() => {
    generateQuickViewHTML(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4);
  }, 100);
}

function generateQuickViewHTML(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4) {
  const body = document.getElementById('qvBody');
  const hasCompare = comparePrice && comparePrice !== '' && comparePrice !== price;
  
  // Collect images
  const images = [image, img2, img3, img4].filter(img => img && img !== '');
  
  // Generate thumbnails HTML
  let thumbnailsHTML = '';
  if (images.length > 1) {
    thumbnailsHTML = `
      <div class="qv-thumbnails">
        ${images.map((img, index) => `
          <button type="button" class="qv-thumb ${index === 0 ? 'active' : ''}" onclick="changeQVImage('${img}', this)">
            <img src="${img}" alt="Thumbnail ${index + 1}">
          </button>
        `).join('')}
      </div>
    `;
  }
  
  body.innerHTML = `
    <div class="qv-grid">
      <div class="qv-images">
        <div class="qv-main-img">
          <div class="qv-img-loader"></div>
          <img src="${image}" alt="${title}" id="qvMainImg" onload="this.classList.add('loaded'); this.previousElementSibling.remove();">
        </div>
        ${thumbnailsHTML}
      </div>
      
      <div class="qv-details">
        <h1 class="qv-title">${title}</h1>
        
        <div class="qv-price">
          ${hasCompare ? `<span class="price-compare">${comparePrice}</span>` : ''}
          <span class="${hasCompare ? 'price-sale' : 'price-regular'}">${price}</span>
        </div>
        
        <form class="qv-form" onsubmit="return handleAddToCart(event, '${variantId}')">
          <div class="qv-qty-wrap">
            <label>Quantity</label>
            <div class="qv-qty">
              <button type="button" class="qv-qty-btn" onclick="changeQty(-1)">−</button>
              <input type="number" id="qvQtyInput" value="1" min="1" class="qv-qty-input" readonly>
              <button type="button" class="qv-qty-btn" onclick="changeQty(1)">+</button>
            </div>
          </div>
          
          <div class="qv-buttons">
            <button type="submit" class="qv-add-btn" ${available !== 'true' ? 'disabled' : ''}>
              ${available === 'true' ? 'Add to Cart' : 'Sold Out'}
            </button>
            <a href="${url}" class="qv-view-link">View Full Details</a>
          </div>
        </form>
      </div>
    </div>
  `;
}

function changeQVImage(imageSrc, thumbButton) {
  const mainImg = document.getElementById('qvMainImg');
  const allThumbs = document.querySelectorAll('.qv-thumb');
  
  // Update active thumbnail
  allThumbs.forEach(thumb => thumb.classList.remove('active'));
  thumbButton.classList.add('active');
  
  // Change main image with loading state
  mainImg.classList.remove('loaded');
  mainImg.src = imageSrc;
}

function closeQuickView() {
  console.log('Closing Quick View');
  const modal = document.getElementById('quickViewModalGlobal');
  if (modal) {
    modal.classList.remove('qv-active');
    document.body.style.overflow = '';
    
    // Clear content after animation
    setTimeout(() => {
      const body = document.getElementById('qvBody');
      if (body) {
        body.innerHTML = '<div class="qv-loading-state"><div class="qv-spinner"></div></div>';
      }
    }, 300);
  }
}

function changeQty(delta) {
  const input = document.getElementById('qvQtyInput');
  if (input) {
    const current = parseInt(input.value) || 1;
    const newValue = current + delta;
    if (newValue >= 1) {
      input.value = newValue;
    }
  }
}

function handleAddToCart(event, variantId) {
  event.preventDefault();
  
  const qtyInput = document.getElementById('qvQtyInput');
  const quantity = qtyInput ? parseInt(qtyInput.value) : 1;
  const button = event.target.querySelector('.qv-add-btn');
  
  if (button) {
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;
    
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      button.textContent = '✓ Added!';
      
      // Trigger cart refresh
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.Shopify && window.Shopify.theme) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      
      setTimeout(() => {
        closeQuickView();
      }, 1200);
    })
    .catch(error => {
      console.error('Error:', error);
      button.textContent = 'Error - Try Again';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
  }
  
  return false;
}

// Make functions globally accessible
window.openQuickView = openQuickView;
window.closeQuickView = closeQuickView;
window.changeQty = changeQty;
window.handleAddToCart = handleAddToCart;
window.changeQVImage = changeQVImage;

// Carousel
class ProductCarousel {
  constructor(element) {
    this.carousel = element;
    this.track = element.querySelector('.carousel-track');
    this.items = Array.from(element.querySelectorAll('.carousel-item'));
    this.prevBtn = element.parentElement.querySelector('.carousel-prev');
    this.nextBtn = element.parentElement.querySelector('.carousel-next');
    
    this.currentIndex = 0;
    this.itemsPerView = {
      desktop: parseInt(element.dataset.desktopItems) || 3,
      tablet: parseInt(element.dataset.tabletItems) || 2,
      mobile: parseInt(element.dataset.mobileItems) || 1
    };
    
    this.init();
  }

  init() {
    this.updateItemsPerView();
    this.updateItemWidths();
    this.updateButtonStates();
    
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());
    
    window.addEventListener('resize', () => {
      this.updateItemsPerView();
      this.updateItemWidths();
      this.updatePosition();
      this.updateButtonStates();
    });

    this.setupTouchEvents();
  }

  updateItemsPerView() {
    const width = window.innerWidth;
    if (width >= 990) {
      this.currentItemsPerView = this.itemsPerView.desktop;
    } else if (width >= 750) {
      this.currentItemsPerView = this.itemsPerView.tablet;
    } else {
      this.currentItemsPerView = this.itemsPerView.mobile;
    }
  }

  updateItemWidths() {
    const gap = 20;
    const containerWidth = this.carousel.offsetWidth;
    const itemWidth = (containerWidth - (gap * (this.currentItemsPerView - 1))) / this.currentItemsPerView;
    
    this.items.forEach(item => {
      item.style.width = `${itemWidth}px`;
    });
  }

  updatePosition() {
    const gap = 20;
    const itemWidth = this.items[0].offsetWidth;
    const offset = -(this.currentIndex * (itemWidth + gap));
    this.track.style.transform = `translateX(${offset}px)`;
  }

  updateButtonStates() {
    const maxIndex = Math.max(0, this.items.length - this.currentItemsPerView);
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex >= maxIndex;
  }

  next() {
    const maxIndex = Math.max(0, this.items.length - this.currentItemsPerView);
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.updatePosition();
      this.updateButtonStates();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updatePosition();
      this.updateButtonStates();
    }
  }

  setupTouchEvents() {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      const diff = startX - currentX;
      const threshold = 50;
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
      isDragging = false;
    });
  }
}

// Close on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeQuickView();
  }
});

// Initialize carousels
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-carousel');
  carousels.forEach(carousel => {
    new ProductCarousel(carousel);
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const carousel = event.target.querySelector('.product-carousel');
    if (carousel) {
      new ProductCarousel(carousel);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related-carousel"] && !Shopify.designMode) return;
  try {
    
// Quick View Functions (if not already defined globally)
if (typeof window.openQuickView === 'undefined') {
  function openQuickView(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4) {
    console.log('Opening Quick View');
    
    const modal = document.getElementById('quickViewModalGlobal');
    const body = document.getElementById('qvBody');
    
    if (!modal || !body) {
      console.error('Modal elements not found');
      return;
    }
    
    modal.classList.add('qv-active');
    document.body.style.overflow = 'hidden';
    body.innerHTML = '<div class="qv-loading-state"><div class="qv-spinner"></div></div>';
    
    setTimeout(() => {
      generateQuickViewHTML(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4);
    }, 100);
  }

  function generateQuickViewHTML(handle, title, price, comparePrice, image, variantId, available, url, img2, img3, img4) {
    const body = document.getElementById('qvBody');
    const hasCompare = comparePrice && comparePrice !== '' && comparePrice !== price;
    const images = [image, img2, img3, img4].filter(img => img && img !== '');
    
    let thumbnailsHTML = '';
    if (images.length > 1) {
      thumbnailsHTML = `
        <div class="qv-thumbnails">
          ${images.map((img, index) => `
            <button type="button" class="qv-thumb ${index === 0 ? 'active' : ''}" onclick="changeQVImage('${img}', this)">
              <img src="${img}" alt="Thumbnail ${index + 1}">
            </button>
          `).join('')}
        </div>
      `;
    }
    
    body.innerHTML = `
      <div class="qv-grid">
        <div class="qv-images">
          <div class="qv-main-img">
            <div class="qv-img-loader"></div>
            <img src="${image}" alt="${title}" id="qvMainImg" onload="this.classList.add('loaded'); this.previousElementSibling.remove();">
          </div>
          ${thumbnailsHTML}
        </div>
        
        <div class="qv-details">
          <h1 class="qv-title">${title}</h1>
          
          <div class="qv-price">
            ${hasCompare ? `<span class="price-compare">${comparePrice}</span>` : ''}
            <span class="${hasCompare ? 'price-sale' : 'price-regular'}">${price}</span>
          </div>
          
          <form class="qv-form" onsubmit="return handleAddToCart(event, '${variantId}')">
            <div class="qv-qty-wrap">
              <label>Quantity</label>
              <div class="qv-qty">
                <button type="button" class="qv-qty-btn" onclick="changeQty(-1)">−</button>
                <input type="number" id="qvQtyInput" value="1" min="1" class="qv-qty-input" readonly>
                <button type="button" class="qv-qty-btn" onclick="changeQty(1)">+</button>
              </div>
            </div>
            
            <div class="qv-buttons">
              <button type="submit" class="qv-add-btn" ${available !== 'true' ? 'disabled' : ''}>
                ${available === 'true' ? 'Add to Cart' : 'Sold Out'}
              </button>
              <a href="${url}" class="qv-view-link">View Full Details</a>
            </div>
          </form>
        </div>
      </div>
    `;
  }

  function changeQVImage(imageSrc, thumbButton) {
    const mainImg = document.getElementById('qvMainImg');
    const allThumbs = document.querySelectorAll('.qv-thumb');
    allThumbs.forEach(thumb => thumb.classList.remove('active'));
    thumbButton.classList.add('active');
    mainImg.classList.remove('loaded');
    mainImg.src = imageSrc;
  }

  function closeQuickView() {
    console.log('Closing Quick View');
    const modal = document.getElementById('quickViewModalGlobal');
    if (modal) {
      modal.classList.remove('qv-active');
      document.body.style.overflow = '';
      setTimeout(() => {
        const body = document.getElementById('qvBody');
        if (body) {
          body.innerHTML = '<div class="qv-loading-state"><div class="qv-spinner"></div></div>';
        }
      }, 300);
    }
  }

  function changeQty(delta) {
    const input = document.getElementById('qvQtyInput');
    if (input) {
      const current = parseInt(input.value) || 1;
      const newValue = current + delta;
      if (newValue >= 1) {
        input.value = newValue;
      }
    }
  }

  function handleAddToCart(event, variantId) {
    event.preventDefault();
    const qtyInput = document.getElementById('qvQtyInput');
    const quantity = qtyInput ? parseInt(qtyInput.value) : 1;
    const button = event.target.querySelector('.qv-add-btn');
    
    if (button) {
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        button.textContent = '✓ Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.Shopify && window.Shopify.theme) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
        setTimeout(() => {
          closeQuickView();
        }, 1200);
      })
      .catch(error => {
        console.error('Error:', error);
        button.textContent = 'Error - Try Again';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      });
    }
    return false;
  }

  window.openQuickView = openQuickView;
  window.closeQuickView = closeQuickView;
  window.changeQty = changeQty;
  window.handleAddToCart = handleAddToCart;
  window.changeQVImage = changeQVImage;

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeQuickView();
    }
  });
}

// Related Products Carousel
class RelatedCarousel {
  constructor(element) {
    this.carousel = element;
    this.track = element.querySelector('.related-track');
    this.items = Array.from(element.querySelectorAll('.related-item'));
    this.prevBtn = element.parentElement.querySelector('.related-prev');
    this.nextBtn = element.parentElement.querySelector('.related-next');
    
    this.currentIndex = 0;
    this.itemsPerView = {
      desktop: parseInt(element.dataset.desktopItems) || 4,
      tablet: parseInt(element.dataset.tabletItems) || 3,
      mobile: parseInt(element.dataset.mobileItems) || 2
    };
    
    this.init();
  }

  init() {
    this.updateItemsPerView();
    this.updateItemWidths();
    this.updateButtonStates();
    
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());
    
    window.addEventListener('resize', () => {
      this.updateItemsPerView();
      this.updateItemWidths();
      this.updatePosition();
      this.updateButtonStates();
    });

    this.setupTouchEvents();
  }

  updateItemsPerView() {
    const width = window.innerWidth;
    if (width >= 990) {
      this.currentItemsPerView = this.itemsPerView.desktop;
    } else if (width >= 750) {
      this.currentItemsPerView = this.itemsPerView.tablet;
    } else {
      this.currentItemsPerView = this.itemsPerView.mobile;
    }
  }

  updateItemWidths() {
    const gap = 20;
    const containerWidth = this.carousel.offsetWidth;
    const itemWidth = (containerWidth - (gap * (this.currentItemsPerView - 1))) / this.currentItemsPerView;
    
    this.items.forEach(item => {
      item.style.width = `${itemWidth}px`;
    });
  }

  updatePosition() {
    const gap = 20;
    const itemWidth = this.items[0].offsetWidth;
    const offset = -(this.currentIndex * (itemWidth + gap));
    this.track.style.transform = `translateX(${offset}px)`;
  }

  updateButtonStates() {
    const maxIndex = Math.max(0, this.items.length - this.currentItemsPerView);
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex >= maxIndex;
  }

  next() {
    const maxIndex = Math.max(0, this.items.length - this.currentItemsPerView);
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.updatePosition();
      this.updateButtonStates();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updatePosition();
      this.updateButtonStates();
    }
  }

  setupTouchEvents() {
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      const diff = startX - currentX;
      const threshold = 50;
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
      isDragging = false;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const relatedCarousels = document.querySelectorAll('.related-carousel');
  relatedCarousels.forEach(carousel => {
    new RelatedCarousel(carousel);
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const carousel = event.target.querySelector('.related-carousel');
    if (carousel) {
      new RelatedCarousel(carousel);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
